import { useStore } from 'zustand';
import { useGridStoreApiOptional } from './GridStoreProvider';
import { emptyGridStore } from './gridStore';
import { buildCombinationKey } from './gridStore.utils';

export const useIsCombinationPending = (combinationKey: string): boolean => {
  const api = useGridStoreApiOptional();

  return useStore(api ?? emptyGridStore, (state) =>
    state.pending.some((item) => buildCombinationKey(item) === combinationKey),
  );
};
